import './Assets/main.css'
import '@callcorpacd/design-tokens/css'
import '@fontsource/inter/latin.css'
import '@fontsource/inter/latin-italic.css'
import '@mdi/font/css/materialdesignicons.css'

import snotify from 'vue3-snotify';
import 'vue3-snotify/style'; // Base styles

import 'vue3-snotify/theme/material';
// Must come after the material theme: the toast restyle wins on source order, not specificity.
import './Assets/toast-restyle.css';

import { createApp } from 'vue'
import { Quasar, Ripple } from 'quasar'
import quasarIconSet from 'quasar/icon-set/mdi-v7'
import '@quasar/extras/mdi-v7/mdi-v7.css'
import 'quasar/src/css/index.sass'

import VueApexCharts from "vue3-apexcharts";
import { vOnEnterDefault } from "./Application/directives/OnEnterDefault";

import App from './App.vue'
import theme from '@/plugins/theme';
import { installVitePreloadRecovery } from '@/Shared/vitePreloadRecovery.js';

// Stale hashed chunks after a lab/prod redeploy (e.g. monaco editor.main-*.js).
installVitePreloadRecovery();

theme.setTheme('defaultTheme');

const app = createApp(App);
app.use(Quasar, {
    plugins: {},
    iconSet: quasarIconSet,
    directives: {
        Ripple
    }
});
app.use(snotify);
app.use(VueApexCharts);
app.provide('snotify', app.config.globalProperties.$snotify);
app.directive('on-enter-default', vOnEnterDefault);

// Override the warn handler to suppress specific warnings
// NOTE: This needs to be temporary until we solve the root cause - which comes from
// our use of 'with' and Vue's proxy implementation. Somehow, they are detecting an
// 'undefined' member name and generating a warning. We will suppress this for now,
// but we need a real solution or this will likely cause a lot of inefficiency.
// DP 2025-04-25
//app.config.warnHandler = (msg, instance, trace) => {
//    // Suppress the specific warning about undefined properties
//    if (msg =='Property undefined was accessed during render but is not defined on instance.') {
//        return; // Do nothing, effectively suppressing the warning
//    }
//    // Log other warnings to the console
//    //console.warn(`[Vue warn]: ${msg}`, instance, trace);
//    console.warn(`[Vue warn]: ${msg}\n${trace}`);
//};

//app.component('StackVertical', VerticalStack);
//app.component('dummy', Dummy);

app.mount('#app');
